import store from 'store'
import { SocketSession } from 'utils/session'
import AuthActions from 'store/redux/auth'

export default socket => {
    socket.on('connect', () => {
        console.tron.log(`SOCKET: CONNECTED SESSION_ID: ${socket.id}`)
        SocketSession.set(socket.id)
    })
    socket.on('disconnect', reason => {
        console.tron.log('SOCKET: DISCONNECT')
        console.tron.log(reason)
        SocketSession.unset()
        store.dispatch(AuthActions.tryReconnect())
    })
}



// WEBPACK FOOTER //
// src/api/listeners/socketStatus.js